/**
 * API Expose Chat
 *
 * Thin wrapper around ApiExposeWorkflowRunner to fit the standard
 * chat-first split-panel layout used across DevCockpit.
 */
import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import ApiExposeWorkflowRunner from './ApiExposeWorkflowRunner';

export default function ApiExposeChat() {
  return (
    <Paper sx={{ width: '100%' }}>
      <Box sx={{ px: 2, py: 1.5, borderBottom: 1, borderColor: 'divider' }}>
        <Typography variant="subtitle2" color="text.secondary">
          Chat / Quick Actions
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Create consumers, mint tokens, rotate keys, set scopes.
        </Typography>
      </Box>
      <ApiExposeWorkflowRunner />
    </Paper>
  );
}

